import type { Reducer } from 'redux';
import { RESET_PAYMENT_GRIDS, SET_PAYMENT_GRIDS } from './actionTypes';
import { getInitialPaymentGridsState } from './paymentGridsInitialState';
import type { PaymentGridAction, PaymentGridsState } from './types';

export const paymentGrids: Reducer<PaymentGridsState, PaymentGridAction> = (
    state: PaymentGridsState = getInitialPaymentGridsState(),
    action: PaymentGridAction
) => {
    switch (action.type) {
        case SET_PAYMENT_GRIDS: {
            return { publishedVersion: action.payload.publishedVersion, scenarios: action.payload.scenarios };
        }
        case RESET_PAYMENT_GRIDS: {
            return getInitialPaymentGridsState();
        }
        default:
            return state;
    }
};
